import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  formLabel: {
    fontWeight: 600,
  },
  icon: {
    fontSize: 16,
    marginLeft: theme.spacing(0.5),
    color: theme.palette.text.linkHelp,
  },
  alert: {
    marginTop: theme.spacing(1),
  },
  alertBottom: {
    marginBottom: theme.spacing(2),
  },
  positionGroups: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(2),
    margin: theme.spacing(1.5, 0, 2),
    maxWidth: 560,
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  positionGroup: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius * 2,
    padding: theme.spacing(1.5, 2),
  },
  positionGroupSelected: {
    borderColor: theme.palette.primary.main,
  },
  positionGroupTitle: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(0.5),
  },
}))

export default styles
